<template>
  <div class="collapse-wrapper">
    <slot name="activator"></slot>
    <b-collapse :id="idName">
      <b-row>
        <b-col>
          <h4 class="details-type-title" v-if="details.cookies.length">
            Cookies
          </h4>
          <div
            class="cookies-details detail-subjects"
            v-for="cookie in details.cookies"
            :key="cookie.id"
          >
            <cookie-collapse-detail :detail="cookie"></cookie-collapse-detail>
          </div>

          <h4 class="details-type-title" v-if="details.localStorage.length">
            Local Storage
          </h4>
          <div
            class="local-details detail-subjects"
            v-for="local in details.localStorage"
            :key="local.id"
          >
            <cookie-collapse-detail :detail="local"></cookie-collapse-detail>
          </div>

          <h4 class="details-type-title" v-if="details.sessionStorage.length">
            Session Storage
          </h4>
          <div
            class="session-details detail-subjects"
            v-for="session in details.sessionStorage"
            :key="session.id"
          >
            <cookie-collapse-detail :detail="session"></cookie-collapse-detail>
          </div>

          <h4 class="details-type-title" v-if="details.others.length">Andet</h4>
          <div
            class="others-details detail-subjects"
            v-for="other in details.others"
            :key="other.id"
          >
            <cookie-collapse-detail :detail="other"></cookie-collapse-detail>
          </div>
        </b-col>
      </b-row>
    </b-collapse>
  </div>
</template>

<script>
import CookieCollapseDetail from "./CookieCollapseDetail.vue";

export default {
  name: "CookieCollapse",
  components: {
    CookieCollapseDetail,
  },
  props: {
    idName: {
      type: String,
      required: true,
    },
    permissionDetails: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    details() {
      const cookies = [];
      const localStorage = [];
      const sessionStorage = [];
      const others = [];

      this.permissionDetails.forEach((detail) => {
        const type = detail.type;
        let value = { ...detail, id: Math.random().toString(36).substr(2, 9) };

        if (type === "cookies") {
          cookies.push(value);
        } else if (type === "local storage") {
          localStorage.push(value);
        } else if (type === "session storage") {
          sessionStorage.push(value);
        } else {
          others.push(value);
        }
      });

      return { cookies, localStorage, sessionStorage, others };
    },
  },
};
</script>

<style lang="scss" scoped>
.collapse-wrapper {
  display: inline;

  #full-consent, #necessary-consent {
    margin-top: 10px;
  }

  .details-type-title {
    padding: 10px 0;
    font-family: $medium;
    font-size: $titles;
  }
  .detail-subjects {
    border-bottom: $senary solid 1px;
    margin-bottom: 15px;
  }
}
</style>